import * as yup from "yup";

const maxImgSizeMB = 2;
const maxImgSizeBytes = maxImgSizeMB * 2 ** 20;

export const editDigitalProductSchema = yup.object().shape({
    img: yup
        .mixed()
        .nullable()
        .test(
            "fileSize",
            `حجم الصورة كبير جدا يجب الا يتعدى حجد الصورة ${maxImgSizeMB}MB`,
            (value) => imageEditSizeValidate(value)
        )
        .test("fileType", "امتداد الصورة يجب ان يكون jpg , png", (value) =>
            imageEditTypeValidate(value)
        ),
    name: yup
        .string()
        .min(3, "اسم المنج قصير جدا")
        .required("ادخل البريد الالكترونى"),
    price: yup
        .number()
        .typeError("يجب ان يكون سعر المنتج رقم ")
        .min(0.001, "سعر المنتج يجب ان يكون رقم اكبر")
        .required("ادخل سعر المنتج"),
    final_price: yup
        .number()
        .typeError("السعر النهائي يجب ان يكون رقم")
        .max(
            yup.ref("price"),
            "نسبة الخصم يجب ان يكون السعر بعد الخصم اكبر من او يساوى السعر الاساسى"
        ),
    ignore_quantity: yup.boolean(),
    quantity: yup
        .number()
        .typeError("يجب ادخال الكمية المتاحة للمنتج وان تكون رقم ")
        // .min(0, "سعر المنتج يجب ان يكون رقم اكبر من او يساوى 0")
        .when("ignore_quantity", ([ignore_quantity], schema) => {
            return ignore_quantity
                ? schema
                : schema
                      .min(0, "يجب ان تكون الكمية اكبر من او تساوى 1")
                      .required("يجب ادخال الكمية المتاحة للمنتج");
        }),
    description: yup.string().min(15, "وصف المنتج قصير جدا"),
    categories: yup
        .mixed()
        .test("check-value", "اختر الفئة خاصة المنتج", (value) => {
            return value.length;
        }),
    unit: yup.mixed().test("check-value", "اختر الوحدة", (value) => {
        return value;
    }),
    is_anis_global_mod: yup.boolean(),
    anis_price_mod: yup
        .mixed()
        .when("is_anis_global_mod", (is_anis_global_mod, schema) => {
            if (is_anis_global_mod) return schema;
            else
                return schema
                    .number()
                    .typeError("يجب ان يكون سعر المنتج رقم ")
                    .min(0.0, "معدل السعر يجب ان يكون رقم اكبر من الصفر")
                    .required("ادخل سعر المنتج");
        }),
    // csv: yup
    //     .mixed()
    //     .nullable()
    //     .test("file-type", "يجب ان يكون الملف من نوع csv", (value) => {
    //         if (typeof value == "string") return true;
    //         const acceptedFormats = [
    //             "text/csv",
    //             "application/vnd.ms-excel",
    //             "application/csv",
    //         ]; // Add more MIME types if needed
    //         return value && acceptedFormats.includes(value.type) ? true : false;
    //     }),
});
// function to validate image if it get as url or not uploaded

const imageEditSizeValidate = (value) => {
    if (value != null && typeof value != "string") {
        return value.size <= maxImgSizeBytes;
    }
    return true;
};

const imageEditTypeValidate = (value) => {
    if (value != null && typeof value != "string") {
        return ["image/jpg", "image/png", "image/jpeg"].includes(value.type);
    }
    return true;
};
